import { render, staticRenderFns } from "./edit-beta-job.vue?vue&type=template&id=3fd6c2e6&scoped=true"
import script from "./edit-beta-job.vue?vue&type=script&lang=js"
export * from "./edit-beta-job.vue?vue&type=script&lang=js"
import style0 from "./edit-beta-job.vue?vue&type=style&index=0&id=3fd6c2e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd6c2e6",
  null
  
)

export default component.exports